import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/main.css'

// Select colors here: https://lobotuerto.com/vuetify-color-theme-builder/
export default createVuetify({
  components,
  directives,
  defaults: {
    VBtn: {
      color: 'grey-lighten-3',
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      dark: {
        colors: {
          primary: "#343434",
          accent: "#01579B",
          secondary: "#FEFEFE",
          success: "#4CAF50",
          info: "#2196F3",
          warning: "#FB8C00",
          error: "#FF5252",
        }
      },
      light: {
        colors: {
          primary: "#343434",
          accent: "#01579B",
          secondary: "#909090",
          success: "#4CAF50",
          info: "#2196F3",
          warning: "#FB8C00",
          error: "#FF5252",
        }
      },
    },
  },
})
